import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

import {ReactComponent as SettingsIcon} from "../../../assets/settings.svg";
import {ReactComponent as MessageIcon} from "../../../assets/message.svg";
import {ReactComponent as StarIcon} from "../../../assets/star.svg";
import {ReactComponent as CandidateIcon} from "../../../assets/candidates.svg";
import {ReactComponent as AddIcon} from "../../../assets/add.svg";
import {ReactComponent as TestsIcon} from "../../../assets/tests.svg";
import {ReactComponent as DashboardIcon} from "../../../assets/dashboard.svg";

const navItems = [
  { section: "MAIN", items: [
    { path: "/company", label: "Dashboard", icon: <DashboardIcon /> },
    { path: "/company/testposts", label: "Test Posts", icon: <TestsIcon />, badge: 12 },
    { path: "/company/createtest", label: "Create Test", icon: <AddIcon /> },
    { path: "/company/candidates", label: "Candidates", icon: <CandidateIcon />, badge: 248 },
    { path: "/company/rankings", label: "Rankings", icon: <StarIcon /> },
  ]},
  { section: "INSIGHTS", items: [
    { path: "/company/messages", label: "Messages", icon: <MessageIcon />, badge: 5 },
  ]},
];

export default function Sidebar() {
  return (
    <aside className="sidebar">

      <div className="sidebar-logo">
        <div className="logo-icon"></div>
        <h2>Skill<span>Hunt</span></h2>
      </div>

      <nav className="sidebar-nav">
        {navItems.map(({ section, items }) => (
          <div key={section} className="nav-section">

            <p className="nav-section-label">{section}</p>

            {items.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/company"}
                className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>

                {item.badge && (
                  <span className="nav-badge">{item.badge}</span>
                )}
              </NavLink>
            ))}

          </div>
        ))}
      </nav>

      <div className="sidebar-footer">

        <NavLink
          to="/company/settings"
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
        >
          <span className="nav-icon">
            <SettingsIcon />
          </span>
          <span className="nav-label">Settings</span>
        </NavLink>

        <div className="sidebar-profile">
          <div className="profile-avatar">AT</div>
          <div className="profile-info">
            <h3>Acme Tech</h3>
            <p>Pro Plan</p>
          </div>
        </div>

      </div>
    </aside>
  );
}